import { ReactElement, memo } from "react";

import {
	ICatalogue,
	ICatalogueCustomization,
	ICatalogueSetItem,
} from "../../../apis/useGetCatalogueData/types";
import { Nullable } from "../../../common/types/types";
import PDPCustomizations from "./customizations/PDPCustomizations";
import PDPSetItems from "./setitems/PDPSetItems";

interface IProps {
	item: ICatalogue;
	selectedSetItems?: Nullable<ICatalogueSetItem>[];
	selectedCustomizations?: Nullable<ICatalogueCustomization>[];
}

const PDPSelections = ({
	item: { food_supplier_customizations, food_supplier_set_items },
	selectedSetItems = [],
	selectedCustomizations = [],
}: IProps): ReactElement => {
	return (
		<div className="PDPSelectionsContainer">
			<PDPSetItems setitems={food_supplier_set_items} selectedSetItems={selectedSetItems} />
			<PDPCustomizations
				customizations={food_supplier_customizations}
				selectedCustomizations={selectedCustomizations}
			/>
		</div>
	);
};

export default memo(PDPSelections);
